module.exports = "<div>\r\n\r\n    <header>\r\n         \r\n        <h1>Service Advisor Home</h1>\r\n        <div class=\"btn btn-info btn-lg\" (click)=\"logout();\">\r\n            <span class=\"glyphicon glyphicon-log-out\" (click)=\"logout();\"></span> Log out\r\n        </div>\r\n     \r\n    </header>\r\n    <ng4-loading-spinner> </ng4-loading-spinner>\r\n    <router-outlet></router-outlet>\r\n    <!-- <footer>\r\n        Copyright © 2017 TATA MOTORS All Rights Reserved.\r\n    </footer> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main